import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from '@rsos/base-components';
import { gspx } from '@rsos/gainsight';
import {
  togglePureWireless,
  selectPureWirelessVisible,
} from '@rsos/reduxDataStore/src/features/additionalLayers/additionalLayersSlice';
import { RegularCheckboxWrapper } from '../LayerCheckbox.styles';

interface PureWirelessLayerControlProps {
  irpVersion?: string;
}

export const PureWirelessLayerControl = memo<PureWirelessLayerControlProps>(
  ({ irpVersion }) => {
    const dispatch = useDispatch();
    const isVisible = useSelector(selectPureWirelessVisible);

    const handleToggle = useCallback(() => {
      const newVisible = !isVisible;
      dispatch(togglePureWireless());

      // Analytics tracking
      const onOffText = newVisible ? 'on' : 'off';
      gspx.trackCustomEvent('Data Map', {
        irpVersion,
        name: `Turn ${onOffText} Pure Wireless`,
        Category: 'Additional Layer',
        'Launched date': new Date(),
      });
    }, [dispatch, isVisible, irpVersion]);

    return (
      <RegularCheckboxWrapper>
        <Checkbox
          label="Indoor floor maps"
          description="911Locate"
          isChecked={isVisible}
          onChange={handleToggle}
        />
      </RegularCheckboxWrapper>
    );
  },
);

export default PureWirelessLayerControl;
